import LayoutVerifications from './LayoutVerifications';

export default LayoutVerifications;
